import React, { useEffect, useState } from "react";

import Editor from "../../../components/form/Editor";
import Input from "../../../components/form/Input";
import Select from "../../../components/form/Select";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import useMutation from "../../../hooks/useMutation";
import FileUploadMultiple from "../../../components/form/FileUploadMultiple";
import DatePicker from "../../../components/form/DatePicker";
import { toast } from "react-toastify";

import { taskAddEdit } from "../../../services/taskService";

import TreeCheckboxDropdown from "../../../components/form/TreeCheckboxDropdown";
import { CategoryTreeList } from "../../../services/catagoryService";

const validation = {
  title: { required: true, message: "Task title is required" },
  publishedAt: { required: true, message: "Published date is required" },
  content: { required: true, message: "Task content is required" },
};

const ManageTask = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [categoryData, setCategoryData] = useState([]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    initialValues: {
      categoryIds: [],
      media: [],
    },
    validationRules: validation,
  });

  // Fetch category data from backend
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await CategoryTreeList({ limit: 50 }); // assumes API returns hierarchical tree

        setCategoryData(res?.docs?.data || []);
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };
    fetchCategories();
  }, []);

  // Populate form if editing
  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        publishedAt: data?.publishedAt ? new Date(data.publishedAt) : null,
        categoryIds: data?.categoryIds || [],
        media: data?.media || [],
      });
    }
  }, [data]);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      return await taskAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
        publishedAt: val.publishedAt
          ? new Date(val.publishedAt).toISOString()
          : null,
        // media:
        //   val.media
        //     ?.filter((f) => f?.file instanceof File)
        //     .map((f) => f.file) || [],
        media:
          [
            ...val.media?.filter((f) => !(f?.file instanceof File)), // existing files (paths/URLs)
            ...val.media
              ?.filter((f) => f?.file instanceof File)
              .map((f) => f.file), // new uploads
          ] || [],

        categoryIds: val.categoryIds || [],
      });
    },
    onSuccess: (res) => {
      toast.success(
        data?._id ? "Task updated successfully" : "Task created successfully"
      );
      getResponse(res);
    },
    onError: (error) => {
      toast.error(error?.error || "Something went wrong. Please try again.");
      console.error(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="col-span-12">
          <Input
            label="Title"
            inputPlaceholder="Enter Title"
            inputName="title"
            value={values?.title}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="col-span-12">
          <Editor
            label="Task Content"
            placeholder="Write task content here..."
            value={values?.content}
            onChange={(val) =>
              handleChange({ target: { name: "content", value: val } })
            }
            {...formValidate(errors, "content")}
          />
        </div>

        <div className="col-span-6">
          <TreeCheckboxDropdown
            label="Categories"
            data={categoryData}
            selected={values?.categoryIds}
            onChange={(selected) =>
              handleChange({ target: { name: "categoryIds", value: selected } })
            }
          />
        </div>
        <div className="col-span-3">
          <Select
            label="Featured"
            placeholder="Select featured"
            selectedValue={values?.featured}
            dropdownData={[
              { name: "Yes", value: 1 },
              { name: "No", value: 2 },
            ]}
            setSelectedValue={(val) =>
              handleChange({ target: { name: "featured", value: val } })
            }
          />
        </div>
        <div className="col-span-3">
          <DatePicker
            label="Published Date"
            value={{
              startDate: values?.publishedAt,
              endDate: values?.publishedAt,
            }}
            onChange={(e) =>
              handleChange({
                target: { value: e?.startDate, name: "publishedAt" },
              })
            }
            {...formValidate(errors, "publishedAt")}
          />
        </div>
        <div className="col-span-12">
          <FileUploadMultiple
            label="Upload Images"
            onChange={(files) =>
              handleChange({ target: { name: "media", value: files } })
            }
            onRemove={(files) =>
              handleChange({ target: { name: "media", value: files } })
            }
            values={values?.media}
            sectionId={values?._id}
          />
        </div>
        <div className="col-span-12 flex justify-center gap-4 mt-6">
          <Button
            buttonType="submit"
            buttonLabel={data?._id ? "Update" : "Save"}
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            buttonLabelClasses="mx-auto"
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel="Cancel"
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            buttonLabelClasses="mx-auto"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageTask;
